import { render, staticRenderFns } from "./editMaterialModal.vue?vue&type=template&id=7c689518&"
import script from "./editMaterialModal.vue?vue&type=script&lang=js&"
export * from "./editMaterialModal.vue?vue&type=script&lang=js&"
import style0 from "./editMaterialModal.vue?vue&type=style&index=0&id=7c689518&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports